import { render } from "./DetailButtons.vue?vue&type=template&id=392363b1&scoped=true"
import script from "./DetailButtons.vue?vue&type=script&lang=ts"
export * from "./DetailButtons.vue?vue&type=script&lang=ts"

import "./DetailButtons.vue?vue&type=style&index=0&id=392363b1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-392363b1"

export default script